import { useReduxState } from 'hooks';
import { getMessageWithPlaceholders } from 'shared-locales';
import { ContentLabel } from 'components/common';
import { NumberStepper } from 'components/common/form';
import {
  HomePageSettingsModulesModuleFooter,
  HomePageSettingsModulesModuleUpdateSettings,
  HomePageSettingsTilesCourses
} from '.';

import type { ModuleInSettings } from './HomePageSettingsModules';

interface Props {
  module: ModuleInSettings;
  updateModule: (module: ModuleInSettings) => void;
}

const HomePageSettingsModulesModuleCoursesNew = ({
  module,
  updateModule
}: Props) => {
  const { messages } = useReduxState();

  const url =
    `/admin/courses?courseType=available&page=1&sortBy=published` +
    `&limit=${module.limit}` +
    `&publishSince=${module.data?.monthsAfterPublish || 3}`;

  return (
    <div>
      <HomePageSettingsTilesCourses module={module} url={url} />

      <HomePageSettingsModulesModuleFooter
        items={[
          {
            label: messages.homePageModuleMonthsFromPublication,
            value: getMessageWithPlaceholders({
              message: messages.homePageModuleMonthsFromPublicationValue,
              placeholders: { months: module.data.monthsAfterPublish }
            })
          },
          {
            label: messages.homePageSettingsModulesNumberOfCourses,
            value: `${messages.homePageSettingsModulesLimitMax} ${module.limit}`
          }
        ]}
      >
        <HomePageSettingsModulesModuleUpdateSettings
          childrenInitialValues={{
            data: { monthsAfterPublish: module.data?.monthsAfterPublish || 3 }
          }}
          module={module}
          onUpdate={updateModule}
          productType="course"
        >
          <ContentLabel
            horizontal={true}
            label={messages.homePageModuleMonthsFromPublication}
          >
            <NumberStepper
              field="data.monthsAfterPublish"
              id="data-months-after-publish"
              label={messages.commonMonths}
              min={1}
              max={12}
              stepValue={1}
            />
          </ContentLabel>
        </HomePageSettingsModulesModuleUpdateSettings>
      </HomePageSettingsModulesModuleFooter>
    </div>
  );
};

export default HomePageSettingsModulesModuleCoursesNew;
